<template>
    <div>
        <div class="wrapper2">   
            <div class="div2">            
                <table class="company-list-table border">
                    <tbody>
                        <tr class="table-head">
                            <td>#</td>
                            <td>Company Name</td>
                            <td>Latest<br />Payrun Processed<span class="custom-date-indicator">(YYYY/MM/DD)</span></td>
                            <td>Latest<br />Challan Filed<span class="custom-date-indicator">(YYYY/MM/DD)</span></td>                            
                            <td>Latest Monthly<br />Salary Return<br />Filed<span class="custom-date-indicator">(YYYY/MM/DD)</span></td>
                            <td>Latest 108<br />return filed<span class="custom-date-indicator">(YYYY/MM/DD)</span></td>
                            <td>Latest 108A<br />return filed<span class="custom-date-indicator">(YYYY/MM/DD)</span></td>
                        </tr>
                    
                        <tr class="hover-bg table-row border-bottom" v-for="(company , index) in paginatedData" :key="company.id">
                            <td>{{index+1}}</td>
                            <td>{{company.name}}</td>
                            <td>{{company.latest_payrun || compliance_placeholder}}</td>
                            <td>{{company.latest_challans || compliance_placeholder}}</td>                            
                            <td>{{company.latest_sod || compliance_placeholder}}</td>
                            <td>{{company.latest_108 || compliance_placeholder}}</td>
                            <td>{{company.latest_108a || compliance_placeholder}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!-- pagination block -->
        <div class="row py-2 float-right no-margin" v-if="paginatedData.length > 0">
            <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
        </div>
        <!-- empty message block -->
        <div class="row py-2 no-margin justify-content-center" v-if="paginatedData.length == 0">
            {{blankmsg}} 
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    export default{
        
        mounted() {
                        
        },
        components: {
            
        },
        data(){            
            
            return {
                notice: "No compliance summary found since you have no company listed yet!",
                pagetitle: 'Companies',
                companies:[],
                blankmsg : 'Hold your breath, we are currently fetching your compliance summary list ...',
                compliance_placeholder : 'N/A',

                length: 10,
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                
            }
        },
        filters:{
            formatDate: function(value){
                if (value && value != '0000-00-00 00:00:00') {
                    return moment(String(value)).format('DD/MM/YYYY')
                }else{
                    value = '';
                }
            },
        },
        methods:{
            getCompanyData: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                axios.get(this.$api_url+'/company/list' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){     
                    this.showoverlay = false;
                    
                    if(response.data.error == 1)
                        this.notice = response.data.notice;
                    else
                    {
                        //console.log(response.data);
                        
                        this.companies = response.data.companies;
                        this.listed_companies = this.companies.length;
                        console.log(this.companies);
                        
                        let total_headcounts = 0;

                        for (let [key, value] of Object.entries(this.companies)) 
                        {
                            total_headcounts = total_headcounts + value.no_of_employees;
                            //console.log(value.no_of_employees);
                        }
                        this.total_headcounts = total_headcounts;

                        if(this.companies.length == 0)
                            this.blankmsg = "No compliance summary found since you have no company listed yet!";

                        this.uflg = response.data.uflg;
                    }
                        
                }.bind(this));
            },

        },
        created: function(){
            this.getCompanyData();
            Fire.$on('reloadUsers', () => {this.getCompanyData()})
        },
        computed: 
        {
            filteredData() 
            {
                let filtered_list = this.companies;
                if (this.search) 
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                
                    if(filtered_list.length == 0)
                            this.blankmsg = "Nothing found.";
                }
                
                return filtered_list;
            },
            paginatedData() 
            {     
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },
        }
    }
</script>